module.exports = __webpack_public_path__ + "img/filter-icon.bd32cf78.svg";